module.exports = __webpack_public_path__ + "static/img/img_cabinet.9d7d0130.png";